/**
 * Strings of the visual overhaul's WP1 (shell and navigation)
 * (docs/design/visual-overhaul.md §11). Merged into the catalogue after
 * every other table, so a key here may override an older one.
 */
import type { Dict } from '../core';

export const shellEn: Dict = {
  // the title bar's trigger opens Jump; it is never called "Search" (L4)
  'tb.search': 'Jump to…',
  'ns.tb.jump': 'Jump to a channel, person or message',
  // the desktop window's caption buttons (frameless, L3)
  'ns.tb.minimize': 'Minimize',
  'ns.tb.maximize': 'Maximize',
  'ns.tb.restore': 'Restore',
  'ns.tb.close': 'Close',
  // the server menu's header carries the counts the sidebar strip had (L2)
  'ns.srv.counts': '{online} · {members}',
  // the channel list's keyboard help (I10, I11)
  'a11y.channels': 'Channels',
  // phones and tablets (§12): the pane's Back, the tablet's drawer, the voice bar, Jump on the rail
  'ns.pane.back': 'Back',
  'ns.pane.nav': 'Channels and people',
  'ns.vbar.label': 'Voice',
  'ns.vbar.open': 'Back to the voice room {channel}',
  'ns.rail.jump': 'Jump to…',
  'ns.side.keys':
    'Alt+Up and Alt+Down move between channels, Alt+Shift+Up and Alt+Shift+Down to unread ones',
};
